import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AdminAuthService } from '../services/auth.service';

// Allows access only to authenticated users in the Admins Cognito group.
// - No session → /login
// - Authenticated but not in Admins → /forbidden
export const adminGuard: CanActivateFn = async () => {
  const auth = inject(AdminAuthService);
  const router = inject(Router);

  const token = await auth.getIdToken();
  if (!token) return router.createUrlTree(['/login']);

  const isAdmin = await auth.isAdmin();
  if (!isAdmin) return router.createUrlTree(['/forbidden']);

  return true;
};
